var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"notification-bar"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"dismiss-button",on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.$t('generalMessages.dismiss')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }